import request from "superagent"
import { getToken, getFirstRefreshFlag, setFirstRefreshFlag } from "app/api/localTools"
import { safeParse, refreshToken } from "./util"
import { isMainHost, redirectLogin } from "../utils/requestUtils"
import stores from "app/stores"

request.Request.prototype.checkToken = function() {
  const token = getToken()
  if (token) {
    this.set("Authorization", "Bearer " + token)
  }else{
    redirectLogin()
  }
  return this
}

request.Request.prototype.promiseify = function() {
    const self = this

    return new Promise((resolve, reject) => {
        self.end((err, res) => {
            if (err) {
              if (!err.status) { // 网络异常
                return reject({
                  status: -1,
                  body: {message: '网络异常'},
                  text: JSON.stringify({message: '网络异常'})
                })
              }

              if (isMainHost(self.url)) {
                if (err.status==401) {
                  redirectLogin()
                } else if (err.status === 423) {
                  stores.auth.locked = true
                } else if (err.status >= 500){ // text could be a html when status > 500
                  return reject({
                    ...res,
                    body: {message: '服务器异常'},
                    text: JSON.stringify({message: '服务器异常'})
                  })
                }
              }
              return reject(res)
            }

            if (window.location.href.indexOf("login") < 0 && !getFirstRefreshFlag()) {
              setFirstRefreshFlag()
              refreshToken()
            }

            resolve(res)
        })
    })
}

request.Request.prototype.commonDispose = function () {
  return this.promiseify()
    .then(
      result => safeParse(result.text),
      error => Promise.reject(safeParse(error.text))
    )
}

/*
 * 为列表结果集从 header 中获取总数量
 */
request.Request.prototype.dataListDispose = function () {
  return this.promiseify()
  .then(
    result => {
      const resData = {
        dataList: safeParse(result.text),
        totalCount: result.header["x-total-count"] * 1
      }
      return resData
    },
    error => Promise.reject(safeParse(error.text))
  )
}





export default request



// WEBPACK FOOTER //
// ./src/app/vendor/request.js